<template>
  <modal
    id="wrapper-time-modal"
    ref="modalTimer"
    white-blur
    no-close-on-backdrop
    block-escape
  >
    <template v-slot:content>
      <div class="modal-wrapper">
        <div class="time-modal-content" :style="bgTimePassing">
          <div class="time-modal-counter">
            <p class="number">{{ counter }}</p>
            <p class="days">{{ label }}</p>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import { Modal } from '../Modal';

export default {
  name: 'Timer',
  components: { Modal },
  props: {
    startTimer: {
      type: Boolean,
      default: false,
    },
    startTime: {
      type: Number,
      default: 0,
    },
    endTime: {
      type: Number,
      default: 24,
    },
    duration: {
      type: Number,
      default: 5000,
    },
    label: {
      type: String,
      default: 'Hours',
    },
  },
  data() {
    return {
      counter: 0,
    };
  },
  methods: {
    showModal() {
      this.$refs.modalTimer.show();
    },
    hideModal() {
      this.$refs.modalTimer.hide();
    },
    startCounter(start, end, duration) {
      let startTimestamp = null;

      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;

        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        this.counter = Math.floor(progress * (end - start) + start);

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          setTimeout(() => {
            this.hideModal();
            this.$emit('stop-counter');
          }, 700);
        }
      };
      window.requestAnimationFrame(step);
    },
  },
  computed: {
    bgTimePassing() {
      return {
        backgroundImage: `url(${this.getImageById('slide-time-passing')})`,
      };
    },
  },

  watch: {
    startTimer: {
      handler(startTimerValue) {
        if (startTimerValue) {
          this.showModal();
          this.startCounter(this.startTime, this.endTime, this.duration);

          this.$nextTick(() => {
            this.$emit('start-counter');
          });
        }
      },
    },
    immediate: true,
  },
};
</script>

<style lang="stylus" scoped>

.time-modal
  &-content
    width 500px
    height 456px
    animation timePassing 1.4s steps(19) infinite

  @keyframes timePassing {
    from {
      background-position-x: 0px;
    }
    to {
      background-position-x: -9500px;
    }
  }

  &-counter
    font-family Bahnschrift
    position absolute
    display flex
    flex-direction column
    align-items center
    z-index 2
    top 549px
    left 843px
    width 112px
    height 113px
    padding-top 5px

    .number
      font-weight 600
      font-size 70px

    .days
      font-weight 700
      font-size 19px
      margin-top -13px
      letter-spacing -0.19px
</style>
